import { atomWithStorage } from 'jotai/utils';

export const SubmitModalIsOpenAtom = atomWithStorage<boolean>('submitModalIsOpen', false);
export const CompleteModalIsOpenAtom = atomWithStorage<boolean>('completeModalIsOpen', false);
export const DeletePropertyCompleteModalIsOpenAtom = atomWithStorage<boolean>(
  'deletePropertyCompleteModalIsOpen',
  false
);
export const TextModalIsOpenAtom = atomWithStorage<boolean>('textModalIsOpen', false);
export const PromptLoginModalIsOpenAtom = atomWithStorage<boolean>('textModalIsOpen', false);
export const LoginModalIsOpenAtom = atomWithStorage<boolean>('LoginModalIsOpen', false);
export const AdModalIsOpenAtom = atomWithStorage<boolean>('adModalIsOpen', false);
export const FileChangeModalIsOpenAtom = atomWithStorage<boolean>('fileChangeModalIsOpen', false);

// お知らせモーダル
export const MemberNewsModalIsOpenAtom = atomWithStorage<boolean>('memberNewsModalIsOpen', false);
export const MemberNewsCompleteModalIsOpenAtom = atomWithStorage<boolean>('memberNewsCompleteModalIsOpen', false);
export type ModalOpenFlg = 'OPEN' | 'CLOSE' | 'OPEN_FORCE';
export const QualifiedModalIsOpenAtom = atomWithStorage<ModalOpenFlg>('qualifiedModalIsOpenAtom', 'OPEN_FORCE');

export const PropertySelectSetAtom = atomWithStorage<boolean>('PropertySelectSetAtom', false);

export const PropertySelectAtom = atomWithStorage<boolean>('PropertySelectAtom', false);
export const PropertySelectDeleteAtom = atomWithStorage<boolean>('PropertySelectDeleteAtom', false);
export const PropertySelectDeleteCompleteAtom = atomWithStorage<boolean>('PropertySelectDeleteCompleteAtom', false);
export const PropertyAreaListAtom = atomWithStorage<boolean>('PropertyAreaListAtom', false);
export const PropertyLineListAtom = atomWithStorage<boolean>('PropertyLineListAtom', false);

export const ErrorMessageAtom = atomWithStorage<string>('errorMessag', '');

export const MemberChangeConfirmFailedAtom = atomWithStorage<boolean>('MemberChangeConfirmFailedAtom', false);
